"use strict";


angular.module("core")
//Filter for sanitizing html
.filter("sanitize", function($sce) {
    return function(htmlCode) {
        //fixme: unresolved function
        return $sce.trustAsHtml(htmlCode);
    };
})

//Filter for percents
//MultiplyBy is optional and ignored if falsy
//If Digits is a number, it filters itself through acts the If Digits<0 and the value is integral, then trailing decimal and 0s are removed
.filter("percent", function($filter) {
    return function(Val, MultiplyBy, Digits) {
        Val = parseFloat(Val) || 0; //Get the value from a string
        if (MultiplyBy) //If MultiplyBy is not given...
            Val *= MultiplyBy;
        Digits = (typeof (Digits) == "number" ? Digits : undefined); //Only accept/use digits if it is a number
        Val = $filter("number")(Val, Digits !== undefined ? Math.abs(Digits) : undefined); //Run through the number filter
        if (Digits < 0) //If digits is negative, remove trailing 0s
            Val = Val.replace(/\.0+$/, "");

        return Val + " %";
    };
})

.filter("deliverydate", function(Language, $filter, $rootScope, moment) {
    function date(value) {
        var localTime = moment.tz(value, "UTC");
        return localTime.format("dddd YYYY-MMM-DD", Language.getLocale());
    }

    date.$stateful = true;
    return date;
})

.filter("thresholddatetime", function(Language, $filter, $rootScope, moment) {
    function thresholddatetime(value) {
        return format_date(Language, moment, $rootScope.user, value, "dddd YYYY-MMM-DD hh:mm a");
    }

    thresholddatetime.$stateful = true;
    return thresholddatetime;
})

.filter("thresholddate", function(Language, $filter, $rootScope, moment) {
    function thresholddate(value) {
        return format_date(Language, moment, $rootScope.user, value, "dddd YYYY-MMM-DD");
    }

    thresholddate.$stateful = true;
    return thresholddate;
})

.filter("thresholdtime", function(Language, $filter, $rootScope, moment) {
    function thresholdtime(value) {
        return format_date(Language, moment, $rootScope.user, value, "hh:mm a");
    }

    thresholdtime.$stateful = true;
    return thresholdtime;
})

.filter("thresholdLocalTime", function(Language, $filter, $rootScope, moment) {
    function thresholdLocalTime(value) {
        if (value) {
            var times = value.split(":");
            var localTime = moment({hour: times[0], minute: times[1], seconds: times[2]});
            return localTime.format("hh:mm a");
        }
        else {
            return "";
        }
    }

    thresholdLocalTime.$stateful = true;
    return thresholdLocalTime;
})

//Standard date
.filter("stddate", function(Language, $filter, $rootScope, moment) {
    function stddate(value) {
        return format_date(Language, moment, $rootScope.user, value, "YYYY-MMM-DD");
    }

    stddate.$stateful = true;
    return stddate;
})

.filter("stddatetime", function(Language, $filter, $rootScope, moment) {
    function stddatetime(value, hide_seconds) {
        return format_date(Language, moment, $rootScope.user, value, hide_seconds ? "YYYY-MMM-DD hh:mm a" : "YYYY-MMM-DD hh:mm:ss a");
    }

    stddatetime.$stateful = true;
    return stddatetime;
})

.filter("datetimetz", function(Language, $filter, $rootScope, moment) {
    function datetimetz(value, hide_seconds) {
        return format_date(Language, moment, $rootScope.user, value, hide_seconds ? "YYYY-MMM-DD hh:mm a zz" : "YYYY-MMM-DD hh:mm:ss a zz");
    }

    datetimetz.$stateful = true;
    return datetimetz;
})

.filter("stdtime", function(Language, $filter, $rootScope, moment) {
    function stdtime(value, hide_seconds) {
        return format_time(Language, moment, $rootScope.user, value, hide_seconds ? "hh:mm a" : "hh:mm:ss a");
    }

    stdtime.$stateful = true;
    return stdtime;
})

.filter("fromNow", function(moment) {
    function fromNow(value) {
        return moment(value).fromNow();
    }

    fromNow.$stateful = true;
    return fromNow;
})

.filter("api_url", function(appConfig) {
    return function(input) {
        return appConfig.API_SERVER + input;
    };
})

.filter("parseFloat", function() {
    return parseFloat;
})

.filter("is_numeric", function() {
    return function(value) {
        return !isNaN(parseFloat(value)) && isFinite(value);
    };
})

.filter("is_null_or_undefined", function() {
    return function(value) {
        return value == null || typeof value === "undefined";
    };
})

.filter("capitalize", function() {
    return function(input) {
        return (!!input) ? input.charAt(0).toUpperCase() + input.substr(1).toLowerCase() : "";
    }
})

.filter("noEmptyDisplay", function(gettextCatalog) {
    return function(value) {
        return value == null || typeof value === "undefined" || value == "" ? gettextCatalog.getString("None") : value;
    };
})

.filter('isEmpty', [function() {
    return function(object) {
        return angular.equals({}, object);
    }
}])

.filter("yesNo", function(gettextCatalog) {
    return function(value) {
        if (value) {
            return gettextCatalog.getString("Yes")
        }
        else {
            return gettextCatalog.getString("No")
        }
    };
})

.filter("getById", function() {
    return function(input, id) {
        var i = 0, len = input.length;
        for (; i < len; i++) {
            if (+input[i].id === +id) {
                return input[i];
            }
        }
        return null;
    }
})

.filter('availableWeekdaysFilter', function() {
    return function(weekdays, availableWeekdays) {
        var result = {};
        angular.forEach(weekdays, function(weekdayName, weekday) {
            if (availableWeekdays.includes(weekday.toString())) {
                result[weekday] = weekdayName;
            }
        });
        return result;
    };
})

.filter('unavailableWeekdaysFilter', function() {
    return function(weekdays, availableWeekdays) {
        var result = {};
        angular.forEach(weekdays, function(weekdayName, weekday) {
            if (!availableWeekdays.includes(weekday.toString())) {
                result[weekday] = weekdayName;
            }
        });
        return result;
    };
})

.filter("weekdayName", function(Language, $rootScope, common) {
    function weekdayName(value) {
        var ISOWeekdays = common.getISOWeekdays(Language.getLocale());
        if (ISOWeekdays && ISOWeekdays.hasOwnProperty(value)) {
            return ISOWeekdays[value];
        }
        return "";
    }

    weekdayName.$stateful = true;
    return weekdayName;
});


//Filter for currency - Uses the normal currency filter, but adds a space between the front symbol
HookFilter("currency", null, function(Val) {
    return typeof (Val) != "string" ? Val : Val.replace(/^(\D+)/, "$1 ");
});

//Hook/override a filter so the value can be manipulated before and after the parent filter is called
function HookFilter(Name, CallbackBefore, CallbackAfter) {
    angular.module("core").config(["$provide", function($provide) {
        $provide.decorator(Name + "Filter", ["$delegate", function($delegate) {
            var srcFilter = $delegate;
            return function() {
                if (CallbackBefore)
                    arguments[0] = CallbackBefore.apply(this, arguments);
                arguments[0] = srcFilter.apply(this, arguments);
                if (CallbackAfter)
                    arguments[0] = CallbackAfter.apply(this, arguments);
                return arguments[0];
            };
        }]);
    }]);
}

function format_date(Language, moment, user, date, format) {
    if (!user)
        return moment().format(format, Language.getLocale());
    var timezone = user.info.timezone;
    var localTime = moment(date).tz(timezone);
    return localTime.format(format, Language.getLocale());
}

function format_time(Language, moment, user, time, format) {
    if (!user || !time)
        return moment().format(format, Language.getLocale());
    var timezone = user.info.timezone;
    var localTime = moment(time).tz(timezone);
    return localTime.format(format, Language.getLocale());
}



//////////////////
// WEBPACK FOOTER
// ./core/Filters.js
// module id = 368
// module chunks = 0